import { Routes } from '@angular/router';

import { adminGuard } from './core/auth/admin.guard';
import { authGuard } from './core/auth/auth.guard';
import { guestGuard } from './core/auth/guest.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./features/auth/auth-layout.component').then(m => m.AuthLayoutComponent),
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./features/auth/login/login.component').then(m => m.LoginComponent),
      },
      {
        path: 'register',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./features/auth/register/register.component').then(m => m.RegisterComponent),
      },
      {
        path: 'forgot-password',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./features/auth/forgot-password/forgot-password.component').then(
            m => m.ForgotPasswordComponent
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./features/auth/reset-password/reset-password.component').then(
            m => m.ResetPasswordComponent
          ),
      },
      {
        path: 'verify-email',
        loadComponent: () =>
          import('./features/auth/verify-email/verify-email.component').then(
            m => m.VerifyEmailComponent
          ),
      },
    ],
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        // Explore sustituye a la antigua landing vacía. La ruta se mantiene en 'home'
        // para no tocar el sidebar (su ítem "Inicio" enlaza a /home y marca activo aquí).
        path: 'home',
        loadComponent: () =>
          import('./features/explore/explore.component').then(m => m.ExploreComponent),
      },
      {
        // Alias canónico: /explore también sirve la misma página.
        path: 'explore',
        loadComponent: () =>
          import('./features/explore/explore.component').then(m => m.ExploreComponent),
      },
      {
        path: 'videos',
        loadComponent: () =>
          import('./features/library/videos-page/videos-page.component').then(
            m => m.VideosPageComponent
          ),
      },
      {
        path: 'images',
        loadComponent: () =>
          import('./features/library/images-page/images-page.component').then(
            m => m.ImagesPageComponent
          ),
      },
      // Back-compat: guards y returnUrl históricos siguen apuntando a /dashboard.
      { path: 'dashboard', redirectTo: '/home' },
      {
        path: 'player/:id',
        loadComponent: () =>
          import('./features/player/player.component').then(m => m.PlayerComponent),
      },
      {
        path: 'billing/success',
        loadComponent: () =>
          import('./features/billing/billing-success.component').then(
            m => m.BillingSuccessComponent
          ),
      },
      {
        path: 'billing/cancel',
        loadComponent: () =>
          import('./features/billing/billing-cancel.component').then(
            m => m.BillingCancelComponent
          ),
      },
      {
        path: 'admin/models',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin-models.component').then(m => m.AdminModelsComponent),
      },
      {
        path: 'admin/explore',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin-explore.component').then(m => m.AdminExploreComponent),
      },
      {
        path: 'admin/models/new',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin-model-form.component').then(m => m.AdminModelFormComponent),
      },
      {
        path: 'admin/models/:id/edit',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin-model-form.component').then(m => m.AdminModelFormComponent),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/profile.component').then(m => m.ProfileComponent),
        children: [
          { path: '', redirectTo: 'info', pathMatch: 'full' },
          {
            path: 'info',
            loadComponent: () =>
              import('./features/profile/tabs/profile-info.component').then(
                m => m.ProfileInfoComponent
              ),
          },
          {
            path: 'subscription',
            loadComponent: () =>
              import('./features/profile/tabs/profile-subscription.component').then(
                m => m.ProfileSubscriptionComponent
              ),
          },
          {
            path: 'history',
            loadComponent: () =>
              import('./features/profile/tabs/profile-history.component').then(
                m => m.ProfileHistoryComponent
              ),
          },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];
